import { render, staticRenderFns } from "./TotalValueLast.vue?vue&type=template&id=11ed8f48"
import script from "./TotalValueLast.vue?vue&type=script&lang=js"
export * from "./TotalValueLast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports